'use strict';

var util = angular.module('gymsystem.util');

util.directive('imagewidget', ['fileManager', function(fileManager) {
    return {
        restrict: 'E',
        template: '<img ng-src="{{getImageSrc()}}" style="max-width:100%;max-height:100%;width:auto;height:auto;padding:10px">',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $scope.getImageSrc = function() {
                return fileManager.fileLinkByKey($scope.settings.imagekey);
            };
        }
    };
}]);
